<template>
  <v-sheet>
    <v-row no-gutters>
      <v-col cols="6">
      </v-col>
      <v-spacer>
      </v-spacer>
      <v-col cols="3">
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            outlined
            dense
            clearable
            single-line
            hide-details
            class="mb-2"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-sheet outlined >
<!--      {{tdata}}-->
      <v-data-table
          :headers="headers"
          :items="tdata"
          :search="search"
          dense
          fixed-header
          no-results-text="No results found for the current search terms. Please try different keywords."
          no-data-text="No results available. Please try other site."
      >

        <template v-slot:item.dataset_name="{ item }">
          <a v-if="item.url" :href="item.url" target="_blank">{{ item.dataset_name }}</a>
          <span v-else>{{ item.dataset_name }}</span>
        </template>

        <template v-slot:item.pmid="{ item, index }">
          <a v-if="item.pmid!=='-'" :href="`https://pubmed.ncbi.nlm.nih.gov/${item.pmid}`" target="_blank">{{ item.pmid }}</a>
          <span v-else>-</span>
        </template>
        <template v-slot:item.sample="{ item, index }">
          <span v-if="item.sample">{{ item.sample }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.title="{ item, index }">
          <span v-if="item.title">{{ item.title }}</span>
          <span v-else>-</span>
        </template>
      </v-data-table>
    </v-sheet>

  </v-sheet>
</template>

<script>
export default {
  name: "DetailExperimentTable",
  props: ["tdata"],
  components: {},
  data() {
    return {
      search: '',
      headers: [
        // {text: 'Normalized ID', value: 'ID', align: 'start', sortable: false},
        {text: 'Original substrate', value: 'original_uniprot_id', align: 'start', sortable: false},
        {text: 'Original site', value: 'original_site', align: 'start', sortable: false},
        {text: 'Dataset', value: 'dataset_name', align: 'start',},
        {text: 'Sample Type', value: 'sample', align: 'start'},
        {text: 'Sample Number', value: 'sample_number', align: 'start'},
        {text: 'PMID', value: 'pmid', align: 'start'},
        // {text: 'Disease type', value: 'disease_type', align: 'start'},
        {text: 'Dataset title', value: 'title', align: 'start',},


      ],
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>

<style>


</style>